import Translator from "../../../../src/components/tools/Translator";
import * as React from 'react';
export default {
  Translator,
  React
};